<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import reportApi from '@/services/api/report.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'



export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Usuarios de Proveedores',
      routes: ["Informes", "Usuarios de Proveedores"]
    },
    model: {
      search: {
        collections: {
          providers: [],
          roles: [],
          statuses: [
            {id: true,
            name: 'Activo'},
            {id: false,
            name: 'Inactivo'},
            
          ],
        },
        filters: {
          provider: null,
          role: null,
          userName: null,
          user: null,
          status: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        error: "Favor seleccionar un proveedor.",
        validations: "required",
        placeholder: 'Seleccionar',
        class: "col-md-4",
        clearable: false,
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
        disabled: this.model.search.collections.providers.length <= 0 || this.model.search.collections.providers.length == 1,
      },
      {
        name: 'role',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Roles',
        placeholder: 'Seleccionar',
        class: "col-md-4",
        clearable: false,
        options: this.model.search.collections.roles,
        value: this.model.search.filters.role,
      },
       {
        name: 'userName',
        component: 'CustomInput',
        type: 'text',
        label: 'Nombre de Usuario',
        placeholder: 'Escriba el Nombre del Usuario',
        icon: 'fa fa-search orange-icon',
        class: "col-md-4",
        leftIcon: true,
        value: this.model.search.filters.userName,
        disabled: this.model.search.filters.userNameDisabled,
      },
       {
        name: 'user',
        component: 'CustomInput',
        type: 'text',
        label: 'Usuario',
        placeholder: 'Escriba el Usuario',
        icon: 'fa fa-search orange-icon',
        class: "col-md-4",
        leftIcon: true,
        value: this.model.search.filters.user,
        disabled: this.model.search.filters.userDisabled,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        class: 'col-md-2',
        clearable: false,
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,

      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await reportApi.getInitFilterProvidersUsers()
        .then(res => {
          this.model.search.collections.providers = res.data.providers
          this.model.search.collections.roles = res.data.roles

          if(res.data.providers.length == 1) {
            this.model.search.filters.provider = res.data.providers[0];
          }
        });
    },
    async onHandlerSearch() {
      
      this.process();
    },
    async process() {
      if(this.hasValue(this.model.search.filters.provider?.id)){
        await ReportServices.getReport('providerusers', {
        companyId : this.model.search.filters.provider?.id,
        roleId : this.model.search.filters.role?.id,
        userName : this.model.search.filters.userName,
        fullName : this.model.search.filters.fullName,
        isActive : this.model.search.filters.status?.id,
        })
        .then(res => DocumentServices.Download(res.data));
      }
    },
   hasValue(param){
      return param !== null && param !== undefined;
    },
  },
}
</script>